import { useState } from 'react'

import { Form } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { EmployeeForSelectFragment } from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/MoneyField'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

import BudgetExceededOptionSelector, {
  BudgetExceededOptionResultType,
} from '../../../BudgetExceededOptionSelector'

interface FormValues {
  limitPerEmployee?: string
  newBudgetLimit?: number
  selectedEmployeeIds: number[]
}

interface AddEmployeeModalFormProps {
  budgetId: number
  currency: string
  budgetLimit: number
  totalAllocatedAmountCents: number
  form: FormikProps<FormValues>
  displayExtraSection: boolean
  setDisplayExtraSection: (display: boolean) => void
  setSelectorResult: (value: BudgetExceededOptionResultType) => void
  employeeIdsWithBudget: number[]
  onEmployeesSelected: (employees: EmployeeForSelectFragment[]) => void
}

const AddEmployeeModalForm = ({
  currency,
  budgetLimit,
  form,
  displayExtraSection,
  totalAllocatedAmountCents,
  setDisplayExtraSection,
  setSelectorResult,
  employeeIdsWithBudget,
  onEmployeesSelected,
}: AddEmployeeModalFormProps) => {
  const [selectedEmployees, setSelectedEmployees] = useState<EmployeeForSelectFragment[]>([])

  const handleOnChange = (value: string) => {
    setDisplayExtraSection(false)
    form.setValues({
      ...form.values,
      limitPerEmployee: value,
    })
    setSelectorResult({
      increaseLimit: 0,
      tryAnotherAllocation: 0,
      type: '',
    })
  }

  const setAllocationValue = (value: number) => {
    form.setFieldValue('limitPerEmployee', value.toString())
  }

  const handleSelectEmployees = (newSelectedEmployees: EmployeeForSelectFragment[]) => {
    setSelectedEmployees(newSelectedEmployees)
    onEmployeesSelected(newSelectedEmployees)
  }

  return (
    <Form padding="s0">
      <MoneyField
        currency={currency}
        label={i18n.t('budgets.detail.allocation_per_employee_modal.limit_per_employee')}
        value={form.values.limitPerEmployee}
        onChange={handleOnChange}
        placeholder={'0'}
        error={form.errors.limitPerEmployee}
      />
      <BudgetExceededOptionSelector
        currency={currency}
        budgetLimit={budgetLimit}
        newAllocationValueCents={Number(form.values.limitPerEmployee) * 100}
        numberOfEmployees={form.values.selectedEmployeeIds.length}
        totalAllocatedAmountCents={totalAllocatedAmountCents}
        setVisible={setDisplayExtraSection}
        visible={displayExtraSection}
        setSelectorResult={setSelectorResult}
        setAllocationValue={setAllocationValue}
        clearErrors={() => form.setErrors({ limitPerEmployee: undefined })}
      />
      {!displayExtraSection && (
        <EmployeeSelector
          value={selectedEmployees}
          multiple
          onSelect={handleSelectEmployees}
          excludeIds={employeeIdsWithBudget}
          usingAccessIds
        />
      )}
    </Form>
  )
}

export default AddEmployeeModalForm
